import api from './api';
import { ApiResponse, ClaimStatus, StationClaim } from '../types';

export const stationClaimService = {
  // Dono de posto: pedir para assumir um posto já cadastrado (ex.: importado da ANP)
  async requestByCnpj(cnpj: string): Promise<ApiResponse<StationClaim>> {
    const response = await api.post<ApiResponse<StationClaim>>('/station-claims', { cnpj });
    return response.data;
  },

  // Dono de posto: meus pedidos
  async getMyClaims(): Promise<ApiResponse<StationClaim[]>> {
    const response = await api.get<ApiResponse<StationClaim[]>>('/station-claims/my');
    return response.data;
  },

  // Admin: pedidos por status
  async getByStatus(status: ClaimStatus): Promise<ApiResponse<StationClaim[]>> {
    const response = await api.get<ApiResponse<StationClaim[]>>('/admin/station-claims', { params: { status } });
    return response.data;
  },

  async approve(id: string): Promise<ApiResponse<StationClaim>> {
    const response = await api.post<ApiResponse<StationClaim>>(`/admin/station-claims/${id}/approve`);
    return response.data;
  },

  async reject(id: string, motivo?: string): Promise<ApiResponse<StationClaim>> {
    const response = await api.post<ApiResponse<StationClaim>>(`/admin/station-claims/${id}/reject`, { motivo });
    return response.data;
  },
};
